module.exports = "mutation DeleteProductComment($commentId:ID!){deleteComment:deleteProductComment(commentId:$commentId){success}}"